import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LOCALE, SUPPORTED_UI_LOCALES, resolvePreferredLocale, type SupportedLocale } from "./locales";
import { LOCALE_NAMESPACES, localeResourceBackend } from "./resource-backend";

export function browserPreferredLocale(): SupportedLocale {
  // node 测试环境没有 window/navigator;这个模块被 SpaPageShared 等纯逻辑模块传递引入,
  // import 即炸会把整片共享工具挡在测试之外。
  if (typeof window === "undefined") return DEFAULT_LOCALE;
  const localPreference = window.localStorage.getItem("lufy.locale");
  return resolvePreferredLocale([localPreference, ...(navigator.languages ?? []), navigator.language], DEFAULT_LOCALE);
}

export function applyDocumentLocale(locale: string): void {
  if (typeof document === "undefined") return;
  document.documentElement.lang = locale;
}

/**
 * 当前语言的资源就绪信号,main.tsx 必须等它 resolve 再 createRoot。
 *
 * 语言包改成按需加载后,资源是一次动态 import;早于它挂载 React 会先闪一屏原始 key。
 * i18n.init() 的 Promise 正好在当前语言 19 个 namespace 全部到位后才 resolve。
 */
export const i18nReady: Promise<void> = i18n
  .use(localeResourceBackend)
  .use(initReactI18next)
  .init({
    lng: browserPreferredLocale(),
    // 三语 key 由 tests/i18n-locale-resources.test.ts 强制对齐且不许为空,fallback 在
    // 运行时命中不了;留着它只会让 en/de 用户首屏白拉一个 zh-CN 语言包(约 155 KB)。
    fallbackLng: false,
    supportedLngs: SUPPORTED_UI_LOCALES,
    defaultNS: "common",
    ns: LOCALE_NAMESPACES,
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  })
  .then(() => applyDocumentLocale(i18n.language));

i18n.on("languageChanged", applyDocumentLocale);

export default i18n;
